import React, { useState, useEffect, useRef, useCallback } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Dialog } from "primereact/dialog";
import { addLocale } from "primereact/api";
import { Calendar } from "primereact/calendar";
import { Toast } from "primereact/toast";
import moment from "moment";
import { Tag } from "primereact/tag";
import { Knob } from "primereact/knob";
import { ProgressBar } from "primereact/progressbar";
import { Tooltip } from "primereact/tooltip";

import { getListaMatricula } from "../../service/Matricula";
import { useDispatch, useSelector } from "react-redux";
import { loading } from "../../actions";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { deleteMatricula } from "../../service/Matricula";
import { getDataFormulario, getDataRevTemplante } from "../../service/Formulario";
import { Formulario } from "../../components/Formulario";
import { generateDocument } from "../../components/GenerateDocument";

import { Steps } from "primereact/steps";
import "./StepsDemo.css";
import classNames from "classnames";
import { ToggleButton } from "primereact/togglebutton";
import { FiltroNivelCurso } from "../../components/FiltroNivelCurso";

import { useHistory } from "react-router-dom";
import { accionPermiso } from "../../utilities/Seguridad";

export const PageFudei = () => {
    const dispatch = useDispatch();

    let ColegioData = {
        id: null,
        idmatricula: null,
        idalumno: null,
        fecha_matricula: "",
        rbd: "",
        colegio: "",
        grado: "",
        run: "",
        digito_verificador: "",
        nombres: "",
        apellido_paterno: "",
        apellido_materno: "",
        diagnostico: "",
        tipo_nee: "",
        observacion: "",
        adicional: "",
    };

    const [dataTable, setDataTable] = useState(ColegioData);
    const [dataTableFilter, setDataTableFilter] = useState(ColegioData);
    const [globalFilter, setGlobalFilter] = useState("");
    const [visibleFudai, setVisibleFudai] = useState(false);
    const [activeIndex, setActiveIndex] = useState(0);
    //const [dataFormulario, setDataFormulario] = useState({});

    const toast = useRef(null);
    const dataFormulario = useRef([]);
    // Reset Filtros Curso y grado
    const filtroRef = useRef(null);

    const registro = useRef(null);

    const [ini, setini] = useState(0);

    // Permisos
    const history = useHistory();
    const permisos = useRef({ superusuario: false, acciones: [] });
    const { usuario, colegio, anio } = useSelector((state) => ({
        usuario: state.usuario,
        colegio: state.colegio,
        anio: state.anio,
    }));

    try {
        permisos.current.superusuario = usuario.superusuario;
        permisos.current.acciones = usuario.permisos.formularios.fudei_revaluacion.acciones;
    } catch (error) {
        permisos.current.acciones = [];
    }
    //----------------------------

    useEffect(() => {
        if (accionPermiso(permisos, "fud_rev_ver")) {
            loadListaMatricula();
        } else {
            history.push("/Acceso");
        }
    }, [anio]);

    const getFiltroNivelCurso = useCallback(
        (data) => {
            if (data.es_nivel) {
                if (data.idnivel == 0) {
                    setDataTableFilter(dataTable);
                } else {
                    setDataTableFilter(dataTable.filter((o) => o.idnivel == data.idnivel));
                }
            } else {
                if (data.id == 0) {
                    setDataTableFilter(dataTable.filter((o) => o.idnivel == data.idnivel));
                } else {
                    setDataTableFilter(dataTable.filter((o) => o.idgrado== data.id &&
                     o.idnivel == data.idnivel));
                }
            }
        },
        [dataTableFilter]
    )

    const registroSet = (result) => {
           registro.current = result;
     }

    const loadListaMatricula = async () => {
        if (colegio.id !== undefined && anio.anio !== undefined) {
            dispatch(loading(true));
            filtroRef.current.click();
            var data = await getListaMatricula(colegio.id, anio.anio, usuario.token);
            if (data.error == 0) {
                setDataTable(data.matricula_pie);
                setDataTableFilter(data.matricula_pie);
            } else {
                if (data.error == 1) {
                    toast.current.show({ severity: "error", summary: "Error", detail: data.mensaje, life: 3000 });
                } else {
                    console.log("Error");
                }
            }

            dispatch(loading(false));
        } else {
            setDataTable([]);
            setDataTableFilter([]);
        }
    };

    const exportExcel = () => {
        let dataExportar = [];
        dataTableFilter?.map((obj) => {
            let o = { ...obj };
            delete o.id;
            delete o.idmatricula;
            delete o.idalumno;
            delete o.digito_verificador;
            delete o.iddiagnostico;
            delete o.idtipo_nee;
            delete o.formulario_fudei;
            delete o.formulario_reevaluacion;
            dataExportar.push(o);
        });
        import("xlsx").then((xlsx) => {
            const worksheet = xlsx.utils.json_to_sheet(dataExportar);
            const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
            const excelBuffer = xlsx.write(workbook, { bookType: "xlsx", type: "array" });
            saveAsExcelFile(excelBuffer, "Fudei_Matricula");
        });
    };

    const saveAsExcelFile = (buffer, fileName) => {
        import("file-saver").then((FileSaver) => {
            let EXCEL_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
            let EXCEL_EXTENSION = ".xlsx";
            const data = new Blob([buffer], {
                type: EXCEL_TYPE,
            });
            FileSaver.saveAs(data, fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION);
        });
    };

    const bodyTemplate = (data, props) => {
        return (
            <>
                <span className="p-column-title">{props.header}</span>
                {data[props.field]}
            </>
        );
    };

    const bodyTemplateDate = (data, props) => {
        return (
            <>
                <span className="p-column-title">{props.header}</span>
                {data[props.field] === null ? "--" : moment(data[props.field]).format("DD/MM/YYYY")}
            </>
        );
    };

    const dataTableHeader = (
        <div className="p-formgrid p-grid p-col-12 p-fluid p-p-0">
            <div className="p-col-12 p-md-6 p-lg-2 p-mt-5">
                <span className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} className="p-mr-3" placeholder="Buscar..." />
                </span>
            </div>

            <div className="p-col-12 p-md-6 p-lg-3">{accionPermiso(permisos, "fud_rev_ver") ? <FiltroNivelCurso getFiltroNivelCurso={getFiltroNivelCurso} reset={filtroRef} /> : ""}</div>

            <div className="p-col-8 p-md-2 p-lg-3 p-offset-4 p-mt-3" style={{ textAlign: "right" }}>
                {accionPermiso(permisos, "fud_rev_exportar") ? <Button type="button" icon="pi pi-file-excel" onClick={exportExcel} className="p-button-success mr-2 p-mr-1" data-pr-tooltip="Descargar" tooltipOptions={{ position: "bottom", mouseTrack: true, mouseTrackTop: 15 }}/> : ""}
                <Button type="button" icon="pi pi-refresh" className="mr-2" onClick={loadListaMatricula} tooltip="Refresh" tooltipOptions={{ position: "bottom", mouseTrack: true, mouseTrackTop: 15 }}></Button>
            </div>
        </div>
    );

    const data = useRef(null);
    const tipo = useRef(null);

    const showFormulario = (row, es_fudei) => {
        data.current = row;
        tipo.current = false;
        setVisibleFudai(true);
        setActiveIndex(0);
        loadDataFormulario(row, es_fudei);
        registro.current = false;
    };

    const downloadFile = async (row) => {
        dispatch(loading(true));
        var data = await getDataRevTemplante(usuario.token, row.formulario_reevaluacion);
        if (data.error == 0) {
            generateDocument(row.iddiagnostico, data.data);
        } else {
            if (data.error == 1) {
                toast.current.show({ severity: "error", summary: "Error", detail: data.mensaje, life: 3000 });
            } else {
                console.log("Error");
            }
        }
        dispatch(loading(false));
    };

    const hideFormulario = () => {
        setVisibleFudai(false);
        if(registro.current){
            loadListaMatricula();
        }
        registro.current = false;
    };

    const actionBodyFudei = (rowData) => {
        return (
            <React.Fragment>
                <div className="actions">
                    {accionPermiso(permisos, "fud_rev_editar_fudei") ? <Button icon="pi pi-file" className="p-button-rounded p-mr-2" onClick={() => showFormulario(rowData, true)} tooltip="Ver" tooltipOptions={{ position: "bottom", mouseTrack: true, mouseTrackTop: 15 }}/> : ""}
                    {/*<Button icon="pi pi-download" className="p-button-rounded p-button-info p-mr-2" onClick={() => downloadFile(rowData)} /> */}
                </div>
                
            </React.Fragment>
        );
    };

    const actionBodyReev = (rowData) => {
        return (
            <React.Fragment>
                <div className="actions">
                    {accionPermiso(permisos, "fud_rev_editar_revaluacion") ? <Button icon="pi pi-file" className="p-button-rounded p-mr-2" style={{ backgroundColor:'#9bbb59',border:'1px solid #9bbb59',color:'#ffffff'}} onClick={() => showFormulario(rowData, false)} tooltip="Ver" tooltipOptions={{ position: "bottom", mouseTrack: true, mouseTrackTop: 15 }}/> : ""}
                    {accionPermiso(permisos, "fud_rev_descargar_revaluacion") ? <Button icon="pi pi-download" className="p-button-rounded p-mr-2" style={{ backgroundColor:'#9370DB',border:'1px solid #9370DB',color:'#ffffff'}} onClick={() => downloadFile(rowData)} tooltip="Descargar" tooltipOptions={{ position: "bottom", mouseTrack: true, mouseTrackTop: 15 }}/>: ""}
                    <div style={{display:'inline-block'}}><Knob value={rowData.porcentaje_revaluacion} size={30} tooltip="Avance" tooltipOptions={{ position: "bottom", mouseTrack: true, mouseTrackTop: 15 }}/></div> 
                </div>
            </React.Fragment>
        );
    };

    const actionBodyStatus = (rowData) => {
        return (
            <div className="actions">
                <Knob value={50} size={33} />
            </div>
        );
    };

    const loadDataFormulario = async (row, es_fudei) => {
        dispatch(loading(true));

        var data = await getDataFormulario(usuario.token, es_fudei ? row.formulario_fudei : row.formulario_reevaluacion);
        setini(ini + 1);
        if (data.error == 0) {
            dataFormulario.current["title"] = data.formulario;
            dataFormulario.current["pages"] = [];
            dataFormulario.current["id"] = es_fudei ? row.formulario_fudei : row.formulario_reevaluacion;
            dataFormulario.current["nombre"] = es_fudei ? row.nombre_fudei : row.nombre_reevaluacion;
            dataFormulario.current["es_fudei"] = es_fudei
            data.grupo.map((grupo, index) => {
                let dat = {
                    label: grupo.grupo,
                    data: grupo.grupo_hijos,
                    data2: grupo.preguntas,
                    template: (item, options) => {
                        let paso = "PASO " + (index + 1);
                        let cssSpan = options.labelClassName + " p-m-0";
                        // <a className="p-menuitem-link p-mb-5" target={item.target} onClick={options.onClick}>
                        return (
                            <a className="p-menuitem-link p-mb-5" target={item.target} onClick={options.onClick}>
                                <Button type="button" className="p-button-rounded p-button-outlined p-m-1" tooltip={item.label} tooltipOptions={{ position: "bottom", mouseTrack: true, mouseTrackTop: 15 }}>
                                    {" "}
                                    <span className={cssSpan}>{paso}</span>
                                </Button>
                            </a>
                        );
                    },
                };

                dataFormulario.current.pages.push(dat);
            });

            // setDataFormulario(dataFormulario);
        } else {
            if (data.error == 1) {
                toast.current.show({ severity: "error", summary: "Error", detail: data.mensaje, life: 3000 });
            } else {
                console.log("Error");
            }
        }

        dispatch(loading(false));
    };

    const bodyTemplateActivo = (data, props) => {
        return (
            <>
                <span className="p-column-title">{props.header}</span>
                <Tag className="p-mr-2" severity={data[props.field] == 1 ? "success" : "warning"} value={data[props.field] == 1 ? "ACTIVO" : "RETIRADO"}></Tag>
            </>
        )
    }

    return (
        <div>
            <div className="p-grid table-demo" style={{ display: !visibleFudai ? "block" : "none" }}>
                <div className="p-col-12">
                    <Toast ref={toast} />
                    <DataTable
                        value={dataTableFilter}
                        paginator
                        id="13"
                        className="p-datatable-customers p-datatable-sm"
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        currentPageReportTemplate="Reg. {first} - {last} de {totalRecords}"
                        rowsPerPageOptions={[5, 10, 25]}
                        rows={5}
                        dataKey="idd"
                        rowHover
                        globalFilter={globalFilter}
                        emptyMessage="No existe información!"
                        loading={false}
                        header={dataTableHeader}
                        size="small"
                        responsiveLayout="scroll"
                    >
                        {/*  <Column field="fecha_matricula" header="Fecha Matricula" sortable body={bodyTemplateDate} ></Column>*/}
                        {/*  <Column field="rbd" header="Rbd" sortable body={bodyTemplate} ></Column> */}
                        <Column field="cod_ensenanza" headerStyle={{ width: "3.5rem" }} bodyStyle={{ textAlign: "center"}} header="Código" body={bodyTemplate}></Column>
                        <Column field="grado" headerStyle={{ width: "4rem",textAlign: "center"  }} bodyStyle={{ textAlign: "center" }}  header="Curso" body={bodyTemplate}></Column>
                        <Column headerStyle={{ width: "10rem"}} field="run" header="Run" sortable body={bodyTemplate}></Column>
                        <Column field="nombres" header="Nombres" sortable body={bodyTemplate}></Column>
                        <Column field="apellido_paterno" header="Paterno" sortable body={bodyTemplate}></Column>
                        <Column field="apellido_materno" header="Materno" sortable body={bodyTemplate}></Column>
                        <Column field="estado_alumno" headerStyle={{ width: "6rem" }} header="Estado" sortable body={bodyTemplateActivo}></Column>
                        <Column field="diagnostico" header="Diagnóstico" sortable body={bodyTemplate}></Column>
                        {/*    <Column field="tipo_nee" header="NEE" sortable body={bodyTemplate}></Column>
            <Column headerStyle={{ width: '10rem', textAlign: 'center' }} field="diagnostico" header="Diagnostico" sortable body={bodyTemplate}></Column>
            
              <Column field="adicional" header="Adicional" sortable body={statusBodyTemplate}></Column> */}
                        <Column header="FUDEI" headerStyle={{ width: "8rem", textAlign: "center" }} bodyStyle={{ textAlign: "center", overflow: "visible", justifyContent: "center" }} body={actionBodyFudei}></Column>
                        <Column header="Fu-Reev." headerStyle={{ width: "16rem", textAlign: "center" }} bodyStyle={{ textAlign: "center", overflow: "visible", justifyContent: "center" }} body={actionBodyReev}></Column>
                        {/*   <Column headerStyle={{ width: '4rem', textAlign: 'center' }} bodyStyle={{ textAlign: 'center', overflow: 'visible', justifyContent: 'center' }} body={actionBodyStatus}></Column> */}
                    </DataTable>
                </div>
            </div>

            <div className="p-grid table-demo">
                <div className="p-col-12">
                    <div
                        className="steps-demo"
                        style={{
                            opacity: visibleFudai ? "1" : "0",
                            transition: visibleFudai ? "all .9s" : "all .0s",
                            height: visibleFudai ? "auto" : 0,
                            visibility: visibleFudai ? "block" : "none",
                        }}
                    >
                        <div className="card">
                            <div className="p-grid">
                                <div className="p-col-fixed" style={{ width: "50px" }}>
                                    <div className="box">
                                        <Button icon="pi pi-arrow-left" className="p-button-rounded" onClick={hideFormulario} />
                                    </div>
                                </div>
                                <div className="p-col">
                                    <div className="box">
                                        <h5>
                                            {dataFormulario.current["title"]} {data.current === null ? "" : data.current.nombres + " " + data.current.apellido_paterno + " " + data.current.apellido_materno + " (" + data.current.nivel_seccion + ") - " + dataFormulario.current["nombre"]}
                                        </h5>
                                        {data.current === null?"":
                                        <div style={{fontSize:'16px',textAlign:'center'}}>{data.current.titulo1_reevaluacion}</div>
                                        }
                                    </div>
                                </div>
                            </div>
                            <Steps model={dataFormulario.current.pages} activeIndex={activeIndex} onSelect={(e) => setActiveIndex(e.index)} readOnly={false} />

                            {dataFormulario.current.pages?.map((page, index) => {
                                return <Formulario key={index} ini={ini} active={activeIndex == index ? true : false} data={page.data} preguntas={page.data2} label={page.label} id={dataFormulario.current["id"]} final={dataFormulario.current.pages.length == index + 1} registroSet={registroSet} es_fudei={dataFormulario.current.es_fudei} />;
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
